// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1o4EH","box":"WorkspacesBox_box__pVwaT","node":"WorkspacesBox_node__2-Bxp"};